module.exports = __webpack_public_path__ + "img/slide-46.e119688d.jpeg";